import React from 'react';

const Edit = () => {
    return (
        <div>
            Edit album
        </div>
    );
};

export default Edit;